import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Formatters, Messages } from '../../../../codegen/Localize';
import { classes, cssClass } from '../../../../style';
import { DataRoleSingleValue } from '../../../../ts/ServerApi/types/IDataRole';
import {  sectionHeaderClass, sectionTitleClass } from '../../../styles/DefinitionSubspaceSharedStyles';
import { useRadioEditContext } from '../../../utils/RadioEditProvider';
import { DefinitionSubspaceValuesControls } from './DefinitionSubspaceValuesToolbar';
import { ValuesSectionEditButtons } from './ValuesSectionEditButtons';
import { ValuesSectionValuesGrid } from './ValuesSectionValuesGrid';

export interface DefinitionSubspaceValuesSectionProps {
  readonly valuesList: ReadonlyArray<DataRoleSingleValue>;
  readonly valueCount: number;
}

const cssPrefix = 'DefinitionSubspaceValuesSection';
const sectionClass = cssClass(cssPrefix, 'section', {flex: 1, display: 'flex', flexDirection: 'column'});
const dataGridWrapperClass = cssClass(cssPrefix, 'topRow', {position: 'relative', flex: 1, width: '100%', fontSize:'14px', display: 'flex', flexDirection: 'column', overflowY: 'hidden'});
const titleRealignClass = cssClass(cssPrefix, 'titleRealign', {display: 'inline-block', marginRight: TabStyles.Spacing.LargeSpace});
const maxRowsMessageClass = cssClass(cssPrefix, 'maxRows', { display: 'inline-block', marginLeft: TabStyles.Spacing.LargeSpace, fontSize:'12px'});

export const  DefinitionSubspaceValuesSection = (props: DefinitionSubspaceValuesSectionProps) => {
  const [filterText, setFilterText] = React.useState('');
  const {isReadonly, setIsEditing, isEditing} = useRadioEditContext();

  const COUNT = Formatters.formatCount(props.valueCount);
  const MAXCOUNT = Formatters.formatCount(10000);

  return <section className={sectionClass}>
    <header className={sectionHeaderClass}>
      <div>
        <h3 className={`${sectionTitleClass} ${titleRealignClass}`}>
          {Messages.dataRoleDefinitionSubspace_Values_Title({COUNT})}
        </h3>
        <ValuesSectionEditButtons
          {...{isReadonly, setIsEditing, isEditing}}/>
        {props.valueCount <= 10000 ? null : <span className={maxRowsMessageClass}>
          {Messages.dataRoleDefinitionSubspace_Values_MaxRowsMessage({MAXCOUNT})}
        </span>}
      </div>
      <span style={{display: 'flex'}}>
        <DefinitionSubspaceValuesControls
        searchText={filterText}
        onChangeSearch={setFilterText}/>
      </span>
    </header>
    <div className={classes(dataGridWrapperClass, 'tb-datarole-values-list')}>
      <ValuesSectionValuesGrid
        valuesList={props.valuesList}
        isEditing={isEditing}
        filterText={filterText}
        resetFilterText={() => setFilterText('')}/>
    </div>
  </section>;
};
